'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  text-decoration: ', ';\n\n  ', ';\n\n  &:before,\n  &:after {\n    text-decoration: none !important;\n    display: inline-block;\n  }\n  ', ';\n  ', ';\n'], ['\n  text-decoration: ', ';\n\n  ', ';\n\n  &:before,\n  &:after {\n    text-decoration: none !important;\n    display: inline-block;\n  }\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    '], ['\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      &:before {\n        content: \'\u2039\';\n        padding-right: 0.25em;\n      }\n    '], ['\n      &:before {\n        content: \'\u2039\';\n        padding-right: 0.25em;\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      &:after {\n        content: \'\u203A\';\n        padding-left: 0.25em;\n      }\n    '], ['\n      &:after {\n        content: \'\u203A\';\n        padding-left: 0.25em;\n      }\n    ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Link = _Text2.default.withComponent('a').extend(_templateObject, function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.hoverline && (0, _styledComponents.css)(_templateObject2);
}, function (props) {
  return props.chevronLeft && (0, _styledComponents.css)(_templateObject3);
}, function (props) {
  return props.chevronRight && (0, _styledComponents.css)(_templateObject4);
});

Link.displayName = 'Link';

Link.propTypes = {
  /** you know, where the link goes */
  href: _propTypes2.default.string,
  /** enable text-decoration: underline */
  underline: _propTypes2.default.bool,
  /** enable text-decoration: underline on hover*/
  hoverline: _propTypes2.default.bool,
  /** add left text arrows */
  chevronLeft: _propTypes2.default.bool,
  /** add right text arrows */
  chevronRight: _propTypes2.default.bool
};

Link.defaultProps = {
  theme: _theme2.default,
  color: 'info'
};

exports.default = Link;